// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"18":"13d66feb","816":"3d56cf8f"}[chunkId] + ".css";
};